import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

export const FILTER_SEPARATOR = ',';

export const PRACTITIONER_FILTER_STORAGE_KEY = 'practitioners';

export const mapPractitionerIdsFilterToPractitionerIds = (practitionerIdsFilter: string | null): PractitionerId[] => {
   return (practitionerIdsFilter?.split(FILTER_SEPARATOR) ?? []).reduce((acc, currentId) => {
      const parsedId = Number(currentId);
      if (!Number.isNaN(parsedId)) {
         acc.push(PractitionerId.of(parsedId));
      }
      return acc;
   }, [] as PractitionerId[]);
};
